import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CounsellingService {
 public token=""
  constructor( private http:HttpClient,public baseURL :BasemodelService) { }
  searchData(searchCriteria: string) {
    const headers = new HttpHeaders({
      'Authorization': ` ${this.token}`
    });
    return this.http.get(this.baseURL.getcounsellingURL()+ "/auth/jwt/student/counselDetailsByAdmNo?admNo=" + searchCriteria, { headers });
  }
  getdata() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.baseURL.getcounsellingURL()+ "/auth/jwt/student/consellingDetails", { headers });
  }
  savedata(data: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(this.baseURL.getcounsellingURL()+ "/auth/jwt/student/saveCounsellingNoteDetails", data, { headers });
  }
}
